'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Commander = require('./components/Commander');

var _Commander2 = _interopRequireDefault(_Commander);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Commander2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-commander/lib/index.js
// module id = 838
// module chunks = 107818501498521